import React from "react";
import styles from "./SplashScreen.module.css";
import logo1x from "../assets/logo@1x.png";
import logo2x from "../assets/logo@2x.png";
import logo3x from "../assets/logo@3x.png";


export default function SplashScreen() {
  return (
    <div className={styles.splash}>
      <div className={styles.card}>
       <img
  src={logo1x}
  srcSet={`${logo1x} 1x, ${logo2x} 2x, ${logo3x} 3x`}
  alt="Logo"
  className={styles.logo}
/>

        <div className={styles.brand}>
          Dr. Fernando <span>International</span>
        </div>
        <div className={styles.loader}></div>
      </div>
    </div>
  );
}
